(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', () => {
        const item = button.parentElement;
        const open = item.classList.contains('active');

        // Cierra todos los demás
        document.querySelectorAll('.faq-item').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.faq-icon').forEach(icon => icon.textContent = '+');

        if (!open) {
        item.classList.add('active');
        button.querySelector('.faq-icon').textContent = '×';
        }
    });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-videos-info"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {

    document.querySelectorAll('.tab-btn').forEach((el, i) => {
     el.addEventListener("click", () => {
       document.querySelectorAll('.tab-btn').forEach((els, i) => els.classList.remove("active"));
       document.querySelectorAll('.tab-content').forEach((elsee, i) => elsee.classList.remove("active"));
    el.classList.add("active");
     document.getElementsByClassName("section-tabs-videos")[0].querySelector(`#${el.dataset.tab}`).classList.add("active");
    });
       
     });
    /*tabs.forEach(tab => {
        tab.addEventListener("click", () => {
            console.log("hola")
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));
        tab.classList.add("active");
        section.querySelector(`#${tab.dataset.tab}`).classList.add("active");
        });
    });*/
    });

  } catch(e) { console.error(e); }
})();
})();
